<ddj-spinner *ngIf="isLoading; else notFound"></ddj-spinner>
<ng-template #notFound>
    <div class="agreement-message-wrapper">
        <h3>The agreement cannot be found.</h3>
    </div>
</ng-template>
